import { render, staticRenderFns } from "./DashboardContents.vue?vue&type=template&id=2644a6a6&scoped=true"
import script from "./DashboardContents.vue?vue&type=script&lang=js"
export * from "./DashboardContents.vue?vue&type=script&lang=js"
import style0 from "./DashboardContents.vue?vue&type=style&index=0&id=2644a6a6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644a6a6",
  null
  
)

export default component.exports